import {BASE_URL} from 'appConstants';

import {get, post} from 'sdk';

export const fetchOneOffChargeReasons = ({locationRef, extraGetParams}) => {
  const url = `${BASE_URL}/v1/payments/one-off-charges/${locationRef}/reasons/`;

  return get(url, extraGetParams);
};

export const createOneOffChargeReason = ({
  label,
  description,
  amount,
  location,
  account
}) => {
  const url = `${BASE_URL}/v1/payments/one-off-charges/${location}/reasons/create/`;

  const data = {
    label,
    description,
    amount,
    location,
    account
  };
  return post(url, data);
};

export const editOneOffChargeReason = ({
  reasonId,
  label,
  description,
  amount,
  locationRef,
  account
}) => {
  const url = `${BASE_URL}/v1/payments/one-off-charges/${locationRef}/reasons/edit/`;

  const data = {
    reason: reasonId,
    label,
    description,
    amount,
    account
  };
  return post(url, data);
};

export const deleteOneOffChargeReason = ({reasonId, locationRef}) => {
  const url = `${BASE_URL}/v1/payments/one-off-charges/${locationRef}/reasons/delete/`;

  const data = {
    reason: reasonId
  };
  return post(url, data);
};

export const fetchPaymentMethods = ({locationRef}) => {
  const url = `${BASE_URL}/v1/payments/one-off-charges/${locationRef}/payment-methods/`;

  return get(url);
};
